import React from 'react';
import { FormattedMessage } from 'react-intl';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import { LanguageSupportUtil } from 'utils/language_support_util';
import { ProPageStrings } from 'react_components/mixins/shared/string_constants_mixin';
import * as styles from './styles/styles.module.scss';

const {
  formText: { termsLink, privacy }
} = ProPageStrings;

const MiniFooter = () => {
  const languageRegionCode = useLanguageRegionCode();

  return (
    <div className={styles.container}>
      <div className={styles.text}>
        <div className={styles.rightsReserved}>
          <FormattedMessage
            defaultMessage="{year} AllTrails, LLC All Rights Reserved"
            values={{
              year: new Date().getFullYear()
            }}
          />
        </div>
        <div className={styles.links}>
          <a href={LanguageSupportUtil.wrapUrlSafe(`/privacy`, languageRegionCode)}>{privacy}</a>|
          <a href={LanguageSupportUtil.wrapUrlSafe(`/terms`, languageRegionCode)}>{termsLink}</a>
        </div>
      </div>
    </div>
  );
};

export default MiniFooter;
